import { useEffect, useCallback } from "react";

export const useKeyboardToClose = (closeModal: () => void) => {
  const handleKeyPress = useCallback(
    (event) => {
      if (
        (event.key === "Escape" ||
          event.key === "Esc" ||
          event.keyCode === 27) === false
      )
        return;

      closeModal();
    },
    [closeModal],
  );

  useEffect(() => {
    window.addEventListener("keyup", handleKeyPress);

    return () => {
      window.removeEventListener("keyup", handleKeyPress);
    };
  }, [handleKeyPress]);
};
